import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import AdminLoginPage from "./AdminLoginPage";
import AdminLayout from "./AdminLayout";
import DashboardPage from "./DashboardPage";
import UserManagePage from "./UserManagePage";
import CodeManagePage from "./CodeManagePage";
import PeopleManagePage from "./PeopleManagePage";
import LogPage from "./LogPage";

function isAdminLoggedIn() {
  const userStr = localStorage.getItem("user");
  if (!userStr) return false;
  try {
    const user = JSON.parse(userStr);
    return user.role === 1;
  } catch {
    return false;
  }
}

function AdminApp() {
  const loggedIn = isAdminLoggedIn();
  const location = useLocation();

  // 已登录管理员访问登录页，自动跳转到仪表盘
  if (loggedIn && location.pathname === "/admin/login") {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return (
    <Routes>
      <Route path="login" element={<AdminLoginPage />} />
      <Route
        path="*"
        element={
          loggedIn ? (
            <AdminLayout>
              <Routes>
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="users" element={<UserManagePage />} />
                <Route path="codes" element={<CodeManagePage />} />
                <Route path="people" element={<PeopleManagePage />} />
                <Route path="logs" element={<LogPage />} />
                <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
              </Routes>
            </AdminLayout>
          ) : (
            <Navigate to="/admin/login" replace />
          )
        }
      />
    </Routes>
  );
}

export default AdminApp;
